export const FETCH_CHANNELS = "FETCH_CHANNELS";
export const FETCH_CHANNELS_SUCCESS = "FETCH_CHANNELS_SUCCESS";
export const FETCH_CHANNELS_FAILED = "FETCH_CHANNELS_FAILED";
